import { combineReducers } from 'redux';
import menus from './menus';
import userInfo from './user-info';
import breadCrumbs from './bread-crumbs';
import breadCrumbsInfo from './bread-crumbs-info';
import sideBar from './slide-bar';
import noticePopInfo from './notice-pop';
import selectDepart from './treeSeletedDepart';
import materialPoolSettingInfo from './material-pool-setting-info';
import circleMemInfo from './circle-mem';
import tagApplicationReducers from '@/pages/activity-manage/merchants/detail/components/merchant-pool/components/tagApplication/_components/tagApplicationReducers';
import proSalesData from './pro-sales-data';
import globalGuide from './auto-guide';
import globalHelpSceneGuide from './help-scene-guide';
import messageCenter from './message-center';
import treeKeys from './tree-select-keys';
import treeLimitCode from './tree-limit-code';
import avenuePoolSettingInfo from './avenue-pool-setting-info';
import isTakeOverscroll from './scroll-top';
import feedback from './new-feedback-instance';
import zongcuFormInfo from './zongzu-form';
import topGlobalNav from './top-global-nav';
import dataPanel from 'datapanelInAcore/store/data-panel';
import duccRoutes from './duccRoutes';

export default combineReducers({
  menus,
  userInfo,
  dataPanel,
  breadCrumbs,
  breadCrumbsInfo,
  sideBar,
  noticePopInfo,
  selectDepart,
  materialPoolSettingInfo,
  tagApplicationReducers,
  proSalesData,
  circleMemInfo,
  circleMemInfo,
  proSalesData,
  globalGuide,
  globalHelpSceneGuide,
  messageCenter,
  treeKeys,
  treeLimitCode,
  avenuePoolSettingInfo,
  isTakeOverscroll,
  feedback,
  zongcuFormInfo,
  topGlobalNav,
  duccRoutes,
});
